import { useState } from 'react';
import useTwinTranslation from '../../utils/hooks/useTwinTranslation';
import { DashboardInner } from '../Dashboard';
import '../Dashboard/dashboard.sass';
import { WidgetDictionary, WidgetFamiliesKeys } from '../Dashboard/useDashboardWidgets/types';
import { BigTitleAndRightLayout } from '../Layout/TitleAndRightLayout';
import { TwinAutoSizer } from '../TwinTable/Adapters';
import useSCDashboardWidgets from './useSCDashboardWidgets';
import DashboardHeader from '../Dashboard/DashboardHeader';

interface SingleCategoryDashboardProps extends SingleCategoryDashboardLogicProps {
    title: string
    forceFamily: WidgetFamiliesKeys
    RightHeader?: JSX.Element
}

const SingleCategoryDashboard: React.FC<SingleCategoryDashboardProps> = ({ title, forceFamily, RightHeader, ...logic}) => {
    const { t } = useTwinTranslation()
    const { saveUserWidgets, getUserWidgets, ...rest } = useSingleCategoryDashboardLogic({ ...logic })
    return (
        <BigTitleAndRightLayout title={t('dashboard', 'Dashboard')} RightHeader={<DashboardHeader {...{ saveUserWidgets, getUserWidgets, title, forceFamily, RightHeader, ...rest }} />} >
            <div className='flex-auto'>
                <TwinAutoSizer>
                    {({ width, height }) => (
                        <DashboardInner {...{ width, height, ...rest }} />
                    )}
                </TwinAutoSizer>
            </div>
        </BigTitleAndRightLayout>
    )
}
interface SingleCategoryDashboardLogicProps {
    name: string
    defaultWidgets: string
    allWidgets: WidgetDictionary
}
const useSingleCategoryDashboardLogic = ({ ...logic }: SingleCategoryDashboardLogicProps) => {
    const [setUpOpened, setSetUpOpened] = useState(false)
    const dashboardWidgetLogic = useSCDashboardWidgets({...logic})
    return { setUpOpened, setSetUpOpened, ...dashboardWidgetLogic }
}


export default SingleCategoryDashboard